<template>
  <div :class="s.card">
    <div :class="s.card_header">
      <span class="me-2">{{ formatTimestamp(reservation.reservation_time, 'MM/DD HH:mm') }}</span>
      <span>{{ reservation.demandSchedule?.demandArea.label || '--' }}</span>
    </div>
    <div :class="s.card_body">
      <div :class="s.card_body_content">
        <div>
          <div>
            <!-- 乗降車地点 -->
            <div :class="s.locations">
              <div
                :class="s.location"
                v-for="(l, i) in locations" :key="i">
                <div>
                  <span class="mt-1">{{ i === 0 ? '乗' : i === locations.length - 1 ? '降' : '経' }}</span>
                </div>
                <div>
                  <div>{{ formatTimestamp(l.time, 'HH:mm') }}</div>
                  <div>{{ l.address?.replace('日本、', '') }}</div>
                  <div>{{ l.title }}</div>

                  <div :class="s.customers">
                    <div
                      :class="s.customer"
                      v-for="(cus, j) in l.customers" :key="j">
                      <div @click.prevent="openDemandOrderResultsModal(cus)">
                        <div :style="{ backgroundColor: cus.color }"><i :class="cus.btnStatus.displayType === 'pickup' ? 'fa-solid fa-arrow-up' : 'fa-solid fa-arrow-down'"/></div>
                        <div :style="{ color: cus.color }">{{ cus.user.username }}</div>
                      </div>
                      <div>
                        <div v-if="cus.flag >= 900" class="py-3">キャンセル済み</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                </div>
              </div>
            </div>
          </div>
          <!-- 顧客一覧 -->
          <div class="mt-2">
            <ul>
              <li
                v-for="c in customers" :key="c.id"
                class="d-flex align-items-center justify-content-between mt-2 p-2 bdr rounded">
                <div>
                  <div class="d-flex align-items-center">
                    <div>{{ c.user.username }}</div>
                    <!-- <router-link
                      class="ms-2"
                      v-if="c.user?.lineUser?.uid"
                      :to="`/chat/${reservation.id}/${c.user_id}`"
                      @click.stop>
                      <button :class="[s.button, s.gray]">
                        チャットを確認
                      </button>
                    </router-link> -->
                  </div>
                  <div>配車時運賃 &yen; {{ c.price || c.price === 0 ? c.price.toLocaleString() : '--' }}</div>
                  <div>確定運賃 &yen; {{ priceResult(c) || priceResult(c) === 0 ? priceResult(c).toLocaleString() : '--' }}</div>
                  <div :class="s.passengers">
                    <span class="me-2" v-for="dp in passengers" :key="dp.id">{{ getPassengerTypeLabel(dp.type) }}: {{ dp.count }}名</span>
                  </div>
                  <div v-if="c.memo?.memo" class="n2br mt-2" v-html="c.memo.memo"/>
                </div>
                <div class="d-flex align-items-center" @click="openDemandOrderResultsModal(c)">
                  <button :class="[s.button, s.gray]">実績を編集</button>
                </div>
              </li>
            </ul>
          </div>
          <!-- オペレーターとチャット -->
          <div class="mt-2">
            <router-link
              :to="`/chat/${reservation.id}/operator`">
              <button :class="[s.button, s.blue]">
                <i class="fa-regular fa-comments me-2"/>オペレーターとチャット
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';

export default {
  name: 'history-demand',
  mixins: [cf],
  props: {
    reservation: Object,
  },
  data() {
    return {
      statusBtns: [
        {
          flag: 2,
          label: '迎車',
          activeFlags: [1],
          color: 'red',
          displayType: 'pickup',
        },
        {
          flag: 11,
          label: '到着',
          activeFlags: [2],
          color: 'blue',
          displayType: 'pickup',
        },
        {
          flag: 21,
          label: '実車',
          activeFlags: [11, 21, 31],
          color: 'yellow',
          displayType: 'pickup',
        },
        {
          flag: 31,
          label: '完了',
          activeFlags: [1, 2, 11, 21, 31],
          color: 'lightgreen',
          displayType: 'destination',
        },
      ],
    };
  },
  computed: {
    ...mapState(['user', 'helper', 'modal']),
    colors() {
      return this.helper.master.system?.demandMarkerColors || [];
    },
    formatReservation() {
      return this.formatDemandReservation(this.reservation, this.colors);
    },
    locations() {
      return this.formatReservation.locations.map((l) => ({
        ...l,
        customers: l.customers.map((c) => ({
          ...c,
          btnStatus: this.btnStatus(l, c),
        })),
      }));
    },
    customers() {
      return this.reservation.demandCustomers;
    },
  },
  methods: {
    priceResult(customer) {
      const orderResult = customer.demandOrderResult;
      return orderResult?.price_discounted;
    },
    passengers(customer) {
      const resultPassenger = customer.demandPassengers.filter((dp) => dp.record_type === 21);
      const estimatePassenger = customer.demandPassengers.filter((dp) => dp.record_type === 11);
      return resultPassenger.length ? resultPassenger : estimatePassenger;
    },
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getPassengerTypeLabel(name) {
      return this.reservation.demandSchedule?.demandArea?.passenger_types?.find((type) => type.name === name)?.label;
    },

    btnStatus(location, customer) {
      const type = location.type;

      let result = {
        flag: null,
        label: '不明',
        activeFlags: [],
        color: 'gray',
      };

      const targetBtn = this.statusBtns.find((btn) => btn.activeFlags.includes(customer.flag) && btn.displayType === type);
      if (targetBtn) result = targetBtn;

      const order = this.formatReservation.locations.findIndex((l) => `${l.lat},${l.lng},${l.time}` === `${location.lat},${location.lng},${location.time}`);
      const beforeLocations = this.formatReservation.locations.filter((_, i) => i < order);
      const isDisabled = !beforeLocations.every((l) => (l.type === 'pickup' && l.customers.every((cus) => cus.flag >= 21)) || (l.type === 'destination' && l.customers.every((cus) => cus.flag >= 31))) || (type === 'pickup' && customer.flag >= 21) || (type === 'destination' && customer.flag >= 31);

      return { ...result, isDisabled: isDisabled || !targetBtn };
    },

    openDemandOrderResultsModal(demandCustomer) {
      if (this.reservation.flag > 900 || demandCustomer.flag > 900) return;
      const data = {
        reservationId: this.reservation.id,
        demandCustomerId: demandCustomer.id,
      };

      if (demandCustomer.demandOrderResult) data.id = demandCustomer.demandOrderResult.id;
      if (this.reservation.demandSchedule.drivers[0]) data.driver_id = this.reservation.demandSchedule.drivers[0].id;

      const args = {
        modalName: 'DemandOrderResult',
        modalTitle: '配車結果',
        data,
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  height: 100%;
  .content {
    height: 100%;
  }
}

.card_container {
  padding: 0 60px;
  height: 100%;
  .slide {
    height: 100%;
  }
}

.card {
  height: 100%;
  display: flex;
  flex-direction: column;
  &_header {
    border-bottom: 1px solid var(--border-gray);
    padding: 4px 12px;
    background-color: var(--bg-gray);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }
  &_body {
    flex: 1;
    padding: 0 12px;
    background-color: #ffffff;
    overflow: scroll;
    &_content {
      position: relative;
      height: fit-content;
      display: flex;
      height: 100%;
      padding: 12px 0;
      > :nth-child(1) {
        flex: 1;
        height: 100%;
        overflow: scroll;
      }
      > :nth-child(2) {
        height: 100%;
        width: 150px;
        display: flex;
        flex-direction: column;
        > * {
          height: auto;
          flex: 1;
          &:not(:first-child) {
            margin-top: 6px;
          }
        }
      }
    }
  }
}

.status_btns {
  height: 100%;
  margin-left: 12px;
}

.locations {
  > *:not(:first-child) {
    position: relative;
    margin-top: 12px;
    &::after {
      content: '';
      position: absolute;
      bottom: 100%;
      left: 12px;
      width: 8px;
      height: 12px;
      background-color: var(--border-gray);
    }
  }
}
.location {
  width: 100%;
  text-align: left;
  background-color: var(--bg-gray);
  border-radius: 4px;
  display: flex;
  align-items: stretch;
  > * {
    padding: 4px 8px;
  }
  > :nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 30px;
    flex-shrink: 0;
    border-right: 1px solid var(--border-gray);
  }
  > :nth-child(2) {
    // text-decoration: underline;
    flex: 1;
  }
}
.buttons {
  display: flex;
  align-items: center;
  padding: 0 12px 12px;
}

.button {
  border: none;
  background-color: transparent;
  padding: 0 16px;
  height: 50px;
  font-weight: bold;
  border-radius: 4px;
  white-space: nowrap;
  &:disabled {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: -4px; left: -4px;
      width: calc(100% + 4px * 2);
      height: calc(100% + 4px * 2);
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
  &.blue {
    background-color: var(--primary-blue);
    color: white;
  }
  &.red {
    background-color: var(--primary-red);
    color: white;
  }
  &.green {
    background-color: var(--primary-green);
    color: white;
  }
  &.gray {
    background-color: var(--primary-gray);
    color: white;
  }
}
.price {
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  .label {
    background-color: var(--bg-gray);
    padding: 12px;
    font-weight: bold;
  }
  .value {
    padding: 12px 12px 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .num {
      display: flex;
      align-items: center;
      > :nth-child(2) {
        padding-left: 50px;
        position: relative;
        span {
          padding: 0 8px;
          background-color: var(--bg-pink);
          display: inline-block;
        }
        &::after {
          content: '→';
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translateY(-50%);
        }
      }
    }
  }
}
.chat {
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  .label {
    background-color: var(--bg-gray);
    padding: 12px;
    font-weight: bold;
  }
  .form {
    padding: 12px;
    display: flex;
    align-items: stretch;
    height: fit-content;
    > textarea {
      flex: 1;
    }
    div {
      button {
        width: 120px !important;
        height: 100%;
        margin: 0;
        margin-left: 6px;
        &.clear {
          width: 50px !important;
          padding: 0;
        }
      }
    }
  }
  .unreadChat {
    position: relative;
    .chats {
      &:not(:first-child) >li {
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: -15px;
          left: 30px;
          width: 3px;
          height: 15px;
          background-color: #daeef2;
        }
        padding: 0 15px 15px 15px;
        &.q {
          &::before {
            background-color: #25db2e;
          }
        }
        &.a {
          &::before {
            background-color: #26aac7;
          }
        }
      }
      >li {
        padding: 15px;
      }
      .mWrap {
        padding: 15px;
        border-radius: 8px;
        background-color: #e2f5df;
      }
      .name {
        font-size: 14px;
      }
      .message {
        font-size: 16px;
        white-space: pre-wrap;
        word-break: break-all;
      }

      .question {
        background-color: #e2f5df;
      }
      .answer {
        background-color: #daeef2;
      }
    }
    .new {
      position: absolute;
      background-color: #f71c55;
      color: #fff;
      font-weight: bold;
      font-size: 14px;
      padding: 4px 12px;
      border-radius: 4px;
      top: 5px;
      right: 6px;
      &_wrap {
        position: relative;
      }
    }
  }
}
.templates {
  width: 100%;
  padding: 6px 12px 0 12px;
  display: flex;
  flex-wrap: wrap;
  > li {
    padding: 4px 12px;
    margin-top: 6px;
    margin-right: 6px;
  }
}

// windowサイズが縦長の時
.wrap.vertical {
  .content {}
  .card_container {
    padding: 0  0 60px 0;
  }
  .card {
    &_body {
      overflow: hidden;
      &_content {
        flex-direction: column-reverse;
        padding: 0 0;
        height: 100%;
        > * {
          &:first-child {
            padding: 12px 0;
            flex: 1;
            > * {
              overflow: scroll;
            }
          }
        }
      }
    }
  }
  .status_btns {
    width: 100%;
    height: auto;
    margin-left: 0;
    flex-direction: row;
    background-color: #ffffff;
    justify-content: space-between;
    flex-wrap: wrap;
    padding-top: 12px;
    > * {
      flex: initial;
      flex-shrink: 0;
      width: calc((100% - 6px) / 2);
      height: 80px;
      &:not(:first-child) {
        margin-top: 0;
      }
      &:not(:nth-child(2n)) {
        margin-right: 6px;
      }
      &:nth-child(n + 3) {
        margin-top: 6px;
      }
    }
  }
}

.customers {
  > * {
    margin-top: 8px;
    margin-bottom: 8px;
  }
}
.customer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > :nth-child(1) {
    align-items: center;
    display: flex;
    > :nth-child(1) {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      border-radius: 60%;
      color: #ffffff;
      margin-right: 6px;
      > i {
        font-size: 16px !important;
      }
    }
  }
}

.passengers {
  > span {
    font-size: 20px;
  }
}

.btn {
  background-color: var(--primary-red);
  color: white;
  cursor: pointer;
  border: 4px solid;
  padding: 0 16px;
  height: 50px;
  font-weight: bold;
  border-color: rgba(255, 255, 255, 0.2) rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.2) rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  white-space: nowrap;
  &:disabled {
    border-color: transparent;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      top: -4px; left: -4px;
      width: calc(100% + 8px);
      height: calc(100% + 8px);
      border-radius: 4px;
      background-color: rgba(#000000, .5);
      mix-blend-mode: multiply;
    }
  }
}
</style>
